import { render, staticRenderFns } from "./HomeTitle.vue?vue&type=template&id=2438cfca"
import script from "./HomeTitle.vue?vue&type=script&lang=js"
export * from "./HomeTitle.vue?vue&type=script&lang=js"
import style0 from "./HomeTitle.vue?vue&type=style&index=0&id=2438cfca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports